import { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const Overlay = ({
  show,
  children,
  parent,
  onEscPressed,
  id
}) => {
  const elmRef = useRef();
  const [, setValue] = useState(0);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  useEffect(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    if (id)
      elm.id = id;
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = "1050";
    elm.style.display = "flex";
    elm.style.justifyContent = "center";
    elm.style.alignItems = "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    parentElement == null ? void 0 : parentElement.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      parentElement == null ? void 0 : parentElement.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  };
  useEffect(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return ReactDOM.createPortal(children, elmRef.current);
};

export { Overlay };
